import React, { useState, useEffect, useRef } from 'react'
import Header from '../../common/header/Header'
import Home_Private_Confidential from '../home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../../common/footer/Footer'
import Common_Images_Transport from '../../common/common_imges_transport/Common_Images_Transport'
import { User_Authentication } from '../../../user_authentication/User_Authentication'
import { Remove_Cart_List, Update_Cart_List } from '../../../api/category_product/Category_Product'
import Loader from '../../../loader/Loader'
import { IMG_BASE_URL } from '../../../config/Config'
import { toast } from "react-toastify";
import Apply_Coupan_Code from './Apply_Coupan_Code'
import Address_List from '../address/Address_List'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCartList } from '../../../redux/actions/cartActions'

import { MdOutlineRemoveShoppingCart } from "react-icons/md";


const Cart = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const enterPressedRef = useRef(false);

    const [is_loading, set_Is_Loading] = useState(false)
    const [removingCartId, setRemovingCartId] = useState(null)
    const [activeShippingAddress, setActiveShippingAddress] = useState(null);
    // const [coupanResponse, setCoupanResponse] = useState(null);
    const { cartlist, shippingAmount, isloading, error } = useSelector((state) => state.cartlist);

    const [cart_list, set_Cart_List] = useState(cartlist || []);
    // const [customImagePopup, set_CustomImagePopup] = useState(false)
    // const [designImage, setDesignImage] = useState(null)

    const [finalshippingAmount, set_Final_ShippingAmount] = useState(0)
    // const [selectedCartIds, setSelectedCartIds] = useState([]);

    const [newQty, set_New_Qty] = useState(1)
    const [tempQty, setTempQty] = useState({});


    //     const handleCustomPopup = (url)=>{
    // set_CustomImagePopup(!customImagePopup)
    // setDesignImage(url)
    //     }

    // const handleCoupanResponse = (response) => {
    //     setCoupanResponse(response);
    // };
    // Calculate total item price using qty * purchase_price

    // useEffect(() => {
    //     if (!Array.isArray(cartlist) || cartlist?.length === 0) return;
    //     if (selectedCartIds?.length === 0) {
    //         const allIds = cartlist?.map(item => item.id);
    //         setSelectedCartIds(allIds);
    //     }

    // }, [cartlist]);


    // const selectedCartItems = cart_list?.filter(item =>
    //     selectedCartIds.includes(item.id)
    // );

    const totalCartPrice = cart_list
        ?.filter(item => item?.product?.current_stock > 0)
        ?.reduce((total, item) => total + (item.qty * item.total_price), 0) || 0;

    // const totalCartPrice = cart_list
    //     ?.filter(item => item?.product?.current_stock > 0)
    //     ?.reduce((total, item) => total + (item?.qty * item?.total_price), 0) || 0;

    // Calculate cart total using total_price from each item

    const cartTotalAmount = cart_list
        ?.filter(item => item?.product?.current_stock > 0)
        ?.reduce((total, item) => {

            const unitPrice = item.total_price / item.qty;
            return total + (unitPrice * item.qty);
        }, 0) || 0;
    console.log("cartTotalAmount", cartTotalAmount)

    const gstTotalAmount = cart_list?.reduce((total, item) => {
        const unitgstAmount = Number(item.gst_amount)
        return total + unitgstAmount;
    }, 0) || 0;

    const total_Coupon_Amount = cart_list?.reduce((total, item) => {
        const unitCouponAmount = Number(item.total_coupon_amount)
        return total + unitCouponAmount;
    }, 0) || 0;



    // For display: total after discount on original totalCartPrice

    const afterDiscountPrice = cartTotalAmount;
    // const afterDiscountPrice = coupanResponse
    //     ? coupanResponse.discount_type === "%"
    //         ? totalCartPrice - (totalCartPrice * (coupanResponse.discount_amount || 0)) / 100
    //         : totalCartPrice - (coupanResponse.discount_amount || 0)
    //     : totalCartPrice;

    const getShippingAmount = (shippingData, cartTotalAmount) => {

        if (!Array.isArray(shippingData)) return 0;

        const matched = shippingData.find(rule =>
            cartTotalAmount >= rule.min_amount && cartTotalAmount <= rule.max_amount
        );

        return matched ? matched.amount : 0;
    };

    useEffect(() => {
        if (shippingAmount?.length > 0 && cartTotalAmount > 0) {
            const fetchshippingAmount = getShippingAmount(shippingAmount, cartTotalAmount);
            set_Final_ShippingAmount(fetchshippingAmount)
        }
        else {
            set_Final_ShippingAmount(0);
        }
    }, [shippingAmount, cartTotalAmount]);


    // Function to handle the active shipping address
    const handleActiveShippingAddress = (addressId) => {
        setActiveShippingAddress(addressId);
    };

    // Sync the local state cart_list with the Redux cartlist when it changes
    useEffect(() => {
        set_Cart_List(cartlist);
    }, [cartlist]);

    // Dispatch Redux action to fetch profile data
    useEffect(() => {
        const result = dispatch(fetchCartList());

    }, [dispatch]);

    // <------- Remove Cart List ----------->
    const Handle_Remove_Cart_List = async (cart_id) => {
        if (removingCartId === cart_id) return;
        setRemovingCartId(cart_id);

        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            const data = {
                cart_id: cart_id
            }
            const response = await Remove_Cart_List(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                toast.success("Remove item from cart")
                set_Cart_List((prevList) => prevList?.filter(item => item.id !== cart_id));
                dispatch(fetchCartList({ showLoader: false }));

            }
        } catch (error) {
            console.error("error", error)
        } finally {
            setRemovingCartId(null);
        }
    }


    const handle_Quantity = async (cart_id, rawValue, energization, certificate) => {
        let value = parseInt(rawValue);



        const cartItem = cart_list?.find(item => item.id === cart_id);
        const maxStock = cartItem?.product?.current_stock;

        let isInvalid = false;
        if (isNaN(value) || value < 1) {
            toast.error("Minimum quantity reached");
            // value = cartItem?.qty;
            isInvalid = true;
        }
        if (value > maxStock) {
            toast.error("Out of stock");
            // value = cartItem?.qty;
            isInvalid = true;
        }

        if (isInvalid) {
            setTempQty(prev => {
                const copy = { ...prev };
                delete copy[cart_id];
                return copy;
            });
            return;
        }


        const unitPrice = cartItem.total_price / cartItem.qty || 0;
        const updatedTotalPrice = unitPrice * value;

        const updateData = {
            cart_id,
            quantity: value,
            total_price: updatedTotalPrice,
            ...(energization != null && { energization }),
            ...(certificate != null && { certificate }),
        };

        try {
            const token = User_Authentication();
            if (!token) {
                throw new Error("User token not found");
            }
            const response = await Update_Cart_List(updateData, {
                Authorization: `Bearer ${token}`,
            });

            if (response?.data?.status == "200") {
                set_Cart_List(prev =>
                    prev.map(item =>
                        item.id === cart_id
                            ? { ...item, qty: value, total_price: updatedTotalPrice }
                            : item
                    )
                );
                dispatch(fetchCartList({ showLoader: false }));
            }
        } catch {
            toast.error("Error updating quantity");
        }

        setTempQty(prev => {
            const copy = { ...prev };
            delete copy[cartItem.id];
            return copy;
        });
    };


    // const handleSelectCartItem = (cartId) => {
    //     setSelectedCartIds((prev) =>
    //         prev.includes(cartId)
    //             ? prev.filter(id => id !== cartId)
    //             : [...prev, cartId]
    //     );
    // };


    const cartReverse = Array.isArray(cart_list) ? [...cart_list].reverse() : [];
    //     const Handle_Update_Cart_list = async (cart_id, newQty, energization, certificate) => {
    // console.log("newQty", newQty);

    //         console.log("energization:", energization);
    //         console.log("certificate:", certificate);


    //         const cartItem = cart_list?.find(item => item.id === cart_id);
    //         const maxStock = cartItem?.product?.current_stock;
    //         const currentQty= cartItem?.qty

    //         if (updateQty > maxStock) {
    //             toast.error(`Current stocks only ${maxStock} items.`);
    //             return;
    //         }
    //         if(updateQty < maxStock){
    //             updateQty= updateQty + 1

    //         }
    //         console.log("updateQty", updateQty);

    // if (updateQty <= 0) {
    //     Handle_Remove_Cart_List(cart_id);
    //     return;
    // }
    // const totalPrice = cartItem?.product?.
    //     purchase_price
    //     * newQty; // Recalculate the total price

    // const update_data = {
    //     cart_id,
    //     quantity: newQty,
    //     total_price: totalPrice,
    //     ...(energization != null && { energization }),
    //     ...(certificate != null && { certificate }),
    // };


    // const totalPricePerItem = cartItem?.total_price;

    // const update_data = {
    //     cart_id,
    //     quantity: newQty,
    //     total_price: totalPricePerItem, // price per unit
    //     ...(energization != null && { energization }),
    //     ...(certificate != null && { certificate }),
    // };


    //         // try {
    //         //     const token = User_Authentication();
    //         //     if (!token) {
    //         //         throw new Error("User token not found");
    //         //     }
    //         //     const response = await Update_Cart_List(update_data, { Authorization: `Bearer ${token}` });
    //         //     console.log("response:", response);

    //         //     if (response?.data?.status == "200") {
    //         //         set_Cart_List(prevList =>
    //         //             prevList?.map(item =>
    //         //                 item.id === cart_id ? { ...item, qty: newQty, total_price: totalPricePerItem } : item
    //         //             )
    //         //         );
    //         //     } else {
    //         //         toast.error('Failed to update cart');
    //         //     }
    //         // } catch (error) {
    //         //     toast.error('Error updating cart');
    //         // }
    //     };


    return (
        <div>

            {/* <-------- Header section's  ---------> */}
            <Header />
            {/* <-------- ToastContainer ------------> */}
            {
                isloading ? (
                    <Loader />
                ) : (
                    <>
                        <div class="gi-breadcrumb bg-center bg-no-repeat bg-cover"
                            style={{
                                backgroundImage: `url(${Common_Images_Transport?.product_bg})`,
                            }}>
                            <div
                                class="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 w-full px-[12px] relative">
                                <div class="flex flex-wrap w-full">
                                    <div class="w-full px-[12px]">
                                        <div class="flex flex-wrap m-0 py-[20px]">
                                            <div class="w-full">
                                                <h1
                                                    class="text-lg font-semibold text-white">Shopping Cart</h1>
                                                <ul class="gi-breadcrumb-list mt-2">
                                                    <li
                                                        class="gi-breadcrumb-item inline-block text-[14px] font-normal tracking-[0.02rem] leading-[1.2] capitalize">
                                                        <a href="/" class="relative text-white"><i
                                                            class="fi-rr-home text-[#fff]"></i> Home</a>
                                                    </li>
                                                    <li
                                                        class="gi-breadcrumb-item inline-block text-[14px] font-normal tracking-[0.02rem] leading-[1.2] capitalize">
                                                        <span class="relative text-white">/ Shopping Cart</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <------- Address section's -----------> */}
                        {
                            cart_list?.length > 0 ? (
                                <>
                                    {
                                        cart_list && (
                                            <section className="gi-cart-section py-[40px] max-[767px]:py-[30px]">
                                                <h2 className="hidden">Cart Page</h2>
                                                <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 w-full px-[12px] relative">
                                                    <div className="flex flex-wrap w-full h-full">
                                                        <div className="gi-cart-leftside min-[992px]:w-[66.66%] w-full px-[12px]">
                                                            {/* <!-- cart content Start --> */}
                                                            {
                                                                cartReverse?.map((cart_list_result) => {
                                                                    return (
                                                                        <div className="gi-product-content mt-3 shadow-xl p-5 relative">
                                                                            <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out flex flex-col sm:flex-row items-center sm:items-start w-full gap-4 sm:gap-6 overflow-hidden">
                                                                                {/* <input
                                                                                    type="checkbox"
                                                                                    checked={selectedCartIds.includes(cart_list_result?.id)}
                                                                                    onChange={() => handleSelectCartItem(cart_list_result?.id)}
                                                                                    className="relative h-6 w-6 cursor-pointer"
                                                                                /> */}
                                                                                <div className="border-[1px] border-solid border-[#eee] rounded-[5px] w-full sm:w-[180px] text-center p-2 flex-shrink-0">

                                                                                    <div className="relative block overflow-hidden">
                                                                                        <img className="m-auto max-w-full z-[1]"
                                                                                            width="130" height="130" src={`${IMG_BASE_URL}${cart_list_result?.product?.single_image?.image_url}`} alt="Product" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="gi-pro-content relative z-[10] text-left w-full">

                                                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                                                        <div className="col-span-1 md:col-span-2">
                                                                                            <Link to={`/product/${cart_list_result?.product?.slug}`}>
                                                                                                <h3
                                                                                                    className="gi-pro-stitle mb-1 font-bold text-gray-900 text-sm">
                                                                                                    {cart_list_result?.product?.name}</h3>
                                                                                            </Link>
                                                                                            <div className='space-y-0.5'>

                                                                                                {cart_list_result?.product?.color?.name && (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">color:<span className="text-gray-500 font-semibold"> {cart_list_result?.product?.color?.name}</span></p>
                                                                                                )}

                                                                                                {cart_list_result?.product_certificate?.name && (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Certification: <span className="text-gray-500 font-semibold">{cart_list_result?.product_certificate?.name}</span></p>
                                                                                                )}

                                                                                                {cart_list_result?.energization?.name && (<p className="text-gray-900 font-normal text-[12px]">Pooja/Energization: <span className="text-gray-500 font-semibold">{cart_list_result?.energization?.name}</span></p>)}

                                                                                                {cart_list_result?.name_wearer && (<p className="text-gray-900 font-normal text-[12px]">Name Wearer: <span className="text-gray-500 font-semibold">{cart_list_result?.name_wearer}</span></p>)}

                                                                                                {cart_list_result?.dob && (<p className="text-gray-900 font-normal text-[12px]">DOB: <span className="text-gray-500 font-semibold">{cart_list_result?.dob}</span></p>)}

                                                                                                {cart_list_result?.birth_place && (<p className="text-gray-900 font-normal text-[12px]">Birth Place: <span className="text-gray-500 font-semibold">{cart_list_result?.birth_place}</span></p>)}

                                                                                                {cart_list_result?.birth_time && (<p className="text-gray-900 font-normal text-[12px]">Birth Time: <span className="text-gray-500 font-semibold">{cart_list_result?.birth_time}</span></p>)}

                                                                                                {cart_list_result?.gender && (<p className="text-gray-900 font-normal text-[12px]">Gender: <span className="text-gray-500 font-semibold">{cart_list_result?.gender}</span></p>)}

                                                                                                {cart_list_result?.gotra && (<p className="text-gray-900 font-normal text-[12px]">Clan/Gotra: <span className="text-gray-500 font-semibold">{cart_list_result?.gotra}</span></p>)}

                                                                                                {cart_list_result?.purpose && (<p className="text-gray-900 font-normal text-[12px]">Primary/Purpose: <span className="text-gray-500 font-semibold">{cart_list_result?.purpose}</span></p>)}

                                                                                                {
                                                                                                    cart_list_result?.producttype?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Select for: <span className="text-gray-500 font-semibold">{cart_list_result?.producttype?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.weights?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Weight: <span className="text-gray-500 font-semibold">{cart_list_result?.weights?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.metals?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Metal: <span className="text-gray-500 font-semibold">{cart_list_result?.metals?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {cart_list_result?.bracelets?.size && <p className="text-gray-900 font-normal text-[12px]">Bracelet Size: <span className="text-gray-500 font-semibold">{cart_list_result?.bracelets?.size}</span></p>}

                                                                                                {cart_list_result?.jewellery_bracelet?.name && <p className="text-gray-900 font-normal text-[12px]">Bracelet Size: <span className="text-gray-500 font-semibold">{cart_list_result?.jewellery_bracelet?.name}</span></p>}
                                                                                                {
                                                                                                    cart_list_result?.designs?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Design: <span className="text-gray-500 font-semibold">{cart_list_result?.designs?.name}</span></p>
                                                                                                    )
                                                                                                }
                                                                                                {
                                                                                                    cart_list_result?.custom_design_image != null && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Custom Design: <span className="text-gray-500 font-semibold">

                                                                                                            {/* <button onClick={()=>handleCustomPopup}>View Custom Image</button> */}

                                                                                                            {/* <img  src={`${IMG_BASE_URL}${cart_list_result?.custom_design_image}`} className="block h-24"/> */}
                                                                                                            <a target='_blank'
                                                                                                                download
                                                                                                                href={`${IMG_BASE_URL}${cart_list_result?.custom_design_image}`}
                                                                                                                className="text-[13px] text-red-700 font-semibold"
                                                                                                            >
                                                                                                                {`${IMG_BASE_URL}${cart_list_result?.custom_design_image}`.split('/').pop()}
                                                                                                            </a>
                                                                                                        </span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.custom_design_image == null && cart_list_result?.designs?.image && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px] ">Selected Design: <span className="text-gray-500 font-semibold">

                                                                                                            {/* <button onClick={()=>handleCustomPopup(`${IMG_BASE_URL}${cart_list_result?.designs?.image}`)}>View Custom Image</button> */}

                                                                                                            {/* <img src={`${IMG_BASE_URL}${cart_list_result?.designs?.image}`} className="block h-20"/> */}
                                                                                                            <a target='_blank'
                                                                                                                download
                                                                                                                href={`${IMG_BASE_URL}${cart_list_result?.designs?.image}`}
                                                                                                                className="text-[13px] text-red-700 font-semibold"
                                                                                                            >
                                                                                                                {`${IMG_BASE_URL}${cart_list_result?.designs?.image}`.split('/').pop()}
                                                                                                            </a>
                                                                                                        </span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.diamonds?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Diamond Quality: <span className="text-gray-500 font-semibold">{cart_list_result?.diamonds?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.diamond_substitute?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Diamond Substitute: <span className="text-gray-500 font-semibold">{cart_list_result?.diamond_substitute?.name}</span></p>
                                                                                                    )
                                                                                                }
                                                                                                {
                                                                                                    cart_list_result?.nevrations?.name && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Nevratan: <span className="text-gray-500 font-semibold">{cart_list_result?.nevrations?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.gemstone_variation && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">{cart_list_result?.gemstone_variation?.type}: <span className="text-gray-500 font-semibold">{cart_list_result?.gemstone_variation?.name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {
                                                                                                    cart_list_result?.custom_variation ? (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">{cart_list_result?.custom_variation?.type}: <span className="text-gray-500 font-semibold">{cart_list_result?.custom_variation?.name}</span></p>
                                                                                                    ) :
                                                                                                        <p className="text-gray-900 font-normal text-[12px]"></p>
                                                                                                }

                                                                                                {/* {
                                                                                                cart_list_result?.personalization?.name && (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Personalization: <span className="text-gray-500 font-semibold">{cart_list_result?.personalization?.name}</span></p>
                                                                                                )
                                                                                            } */}

                                                                                                {
                                                                                                    cart_list_result?.personalization_name != null && (
                                                                                                        <p className="text-gray-900 font-normal text-[12px]">Personalization: <span className="text-gray-500 font-semibold font-semibold">{cart_list_result?.personalization_name}</span></p>
                                                                                                    )
                                                                                                }

                                                                                                {cart_list_result?.product?.origin?.name && (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Origin: <span className="text-gray-500 font-semibold">{cart_list_result?.product?.origin?.name}</span></p>
                                                                                                )}

                                                                                                {cart_list_result?.product?.shape?.name ? (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Shape: <span className="text-gray-500 font-semibold">{cart_list_result?.product?.shape?.name}</span></p>
                                                                                                ) : (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]"> </p>
                                                                                                )}

                                                                                                {cart_list_result?.sizes?.name ? (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Size: <span className="text-gray-500 font-semibold">{cart_list_result?.sizes?.name}</span></p>
                                                                                                ) : (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]"> </p>
                                                                                                )}

                                                                                                {cart_list_result?.country?.name ? (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]">Country: <span className="text-gray-500 font-semibold">{cart_list_result?.country?.name}</span></p>
                                                                                                ) : (
                                                                                                    <p className="text-gray-900 font-normal text-[12px]"> </p>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="gi-single-qty gap-3 w-full md:w-auto mt-3 md:mt-1 text-left md:text-end min-h-[165px]">
                                                                                            <div className="flex gap-2 items-center justify-start md:justify-end">
                                                                                                <div className="font-semibold text-gray-900 text-[12px]">Qty</div>
                                                                                                <div
                                                                                                    className="qty-plus-minus w-[100px] h-[36px] p-[10px] border-[1px] border-gray-200 overflow-hidden relative
                                                                                             flex items-center justify-between">
                                                                                                    <div className="dec gi-qtybtn cursor-pointer" onClick={() => {
                                                                                                        const newQty = (tempQty[cart_list_result?.id] ?? cart_list_result?.qty) - 1;

                                                                                                        handle_Quantity(cart_list_result?.id, newQty, cart_list_result?.energization?.id, cart_list_result?.certificate)
                                                                                                    }}>-</div>
                                                                                                    <input className="qty-input w-6 text-[12px] font-semibold text-center" type="number" name="ms_qtybtn" value={tempQty[cart_list_result?.id] ?? cart_list_result?.qty} onChange={(e) => {

                                                                                                        if (e.target.value.startsWith("-")) return;

                                                                                                        setTempQty({
                                                                                                            ...tempQty,
                                                                                                            [cart_list_result.id]: e.target.value,
                                                                                                        })
                                                                                                    }
                                                                                                    }
                                                                                                        onKeyDown={(e) => {
                                                                                                            if (e.key === "Enter") {
                                                                                                                enterPressedRef.current = true;
                                                                                                                const newQty = e.target.value;
                                                                                                                handle_Quantity(cart_list_result?.id,
                                                                                                                    newQty, cart_list_result?.energization?.id, cart_list_result?.certificate);
                                                                                                                e.target.blur(); // optional: remove focus
                                                                                                            }
                                                                                                        }}
                                                                                                        onBlur={(e) => {
                                                                                                            if (enterPressedRef.current) {
                                                                                                                enterPressedRef.current = false;
                                                                                                                return;
                                                                                                            }
                                                                                                            const newQty = e.target.value;
                                                                                                            handle_Quantity(cart_list_result?.id,
                                                                                                                newQty, cart_list_result?.energization?.id, cart_list_result?.certificate)
                                                                                                        }} />
                                                                                                    <div className="inc gi-qtybtn cursor-pointer" onClick={() => {
                                                                                                        const newQty = (tempQty[cart_list_result?.id] ?? cart_list_result?.qty) + 1;

                                                                                                        handle_Quantity(cart_list_result?.id, newQty, cart_list_result?.energization?.id, cart_list_result?.certificate)
                                                                                                    }}>+</div>
                                                                                                </div>
                                                                                            </div>
                                                                                            {/* <------ Total Price of the One products ------------> */}
                                                                                            <div className="gi-single-cart text-gray-800 text-[13px] font-semibold mt-3">
                                                                                                ₹ {cart_list_result?.total_price
                                                                                                }
                                                                                            </div>
                                                                                            {
                                                                                                cart_list_result?.product?.current_stock > 0 ? (
                                                                                                    <div className="text-[12px] text-green-500 mt-1">
                                                                                                        ({cart_list_result?.product?.current_stock} IN STOCK)
                                                                                                    </div>
                                                                                                ) : (
                                                                                                    <div className="text-[12px] text-red-500 mt-1">
                                                                                                        (OUT OF STOCK)
                                                                                                    </div>
                                                                                                )
                                                                                            }

                                                                                            {/* <----------- Remove the Add To Cart Product's ------------> */}
                                                                                            <div className="absolute -bottom-2 right-0 text-[#9F2225] text-lg font-medium" >
                                                                                                {removingCartId === cart_list_result?.id ? (
                                                                                                    <span
                                                                                                        className="inline-block h-4 w-4 rounded-full border-2 border-[#9F2225] border-t-transparent animate-spin"
                                                                                                        aria-label="Removing item"
                                                                                                    ></span>
                                                                                                ) : (
                                                                                                    <i className="fi-rr-trash mr-2 cursor-pointer" onClick={() => Handle_Remove_Cart_List(cart_list_result?.id)}></i>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                            {/* <!--cart content End --> */}
                                                            <Address_List  // Pass the address list (or any other required props)
                                                                onActiveShippingAddressChange={handleActiveShippingAddress} />
                                                        </div>
                                                        <div className="gi-cart-rightside min-[992px]:w-[33.33%] w-full px-[12px] mt-4">
                                                            {/* <Apply_Coupan_Code onCoupanApply={handleCoupanResponse} /> */}
                                                            <div className="gi-sidebar-wrap p-[15px] shadow-xl mb-[0]">
                                                                <div className="gi-sidebar-block">
                                                                    <div className="gi-sb-block-content mb-[0] border-b-[0]">
                                                                        <div className="gi-cart-summary-bottom">
                                                                            <div className="gi-cart-summary">
                                                                                <h2 className="font-bold text-[14px] text-black mb-2">Order Summary</h2>
                                                                                <div className="flex justify-between items-center mb-[10px]">
                                                                                    <span className="text-left text-gray-700 text-[13px] leading-[24px] font-medium tracking-[0]">Price</span>
                                                                                    <span className="text-right text-grat-500 text-[13px] leading-[24px] font-medium">
                                                                                        ₹ {cartTotalAmount}/-
                                                                                    </span>
                                                                                </div>
                                                                                {total_Coupon_Amount > 0 && (
                                                                                    <div className="flex justify-between items-center mb-[10px]">
                                                                                        <span className="text-left text-gray-700 text-[13px] leading-[24px] font-medium tracking-[0]">Coupon Discount</span>
                                                                                        <span className="text-right text-gray-700 text-[13px] leading-[24px] font-medium">- ₹ {total_Coupon_Amount || 0.00}</span>
                                                                                    </div>
                                                                                )}
                                                                                <div className="flex justify-between items-center mb-[10px]">
                                                                                    <span className="text-left text-gray-700 text-[13px] leading-[24px] font-medium tracking-[0]">Shipping</span>
                                                                                    <span className="text-right text-gray-700 text-[13px] leading-[24px] font-medium">₹ {finalshippingAmount || 0.00}</span>
                                                                                </div>
                                                                                {/* Gst Amount */}

                                                                                {gstTotalAmount > 0 && (
                                                                                    <div className="flex justify-between items-center mb-[10px]">
                                                                                        <span className="text-left text-gray-700 text-[13px] leading-[24px] font-medium tracking-[0]">Tax</span>
                                                                                        <span className="text-right text-gray-700 text-[13px] leading-[24px] font-medium">₹ {gstTotalAmount || 0.00}</span>
                                                                                    </div>
                                                                                )}

                                                                                {/* Total Payment including the shipping fee */}
                                                                                <div className="gi-cart-summary-total border-t-[1px] border-solid border-[#eee] pt-[19px] mb-[0] mt-[16px] flex justify-between items-center">
                                                                                    <span className="text-left text-[13px] font-semibold text-gray-800 leading-[24px] tracking-[0]">
                                                                                        Order Total
                                                                                    </span>
                                                                                    <span className="text-right text-[14px] font-semibold text-[#9D2326] leading-[24px] tracking-[0]">
                                                                                        ₹ {afterDiscountPrice + finalshippingAmount + gstTotalAmount - total_Coupon_Amount}/-

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <button type="button" onClick={() => {
                                                                                // if (selectedCartIds.length === 0) {
                                                                                //     toast.error("Please select at least one item");
                                                                                //     return;
                                                                                // }
                                                                                if (!activeShippingAddress) {
                                                                                    toast("Please add a shipping address before proceeding.");
                                                                                    return;
                                                                                }
                                                                                navigate("/order-place", {
                                                                                    state: {
                                                                                        cart_list: cart_list,
                                                                                        // coupanResponse: coupanResponse,
                                                                                        activeShippingAddress: activeShippingAddress,
                                                                                        finalshippingAmount: finalshippingAmount,
                                                                                        gstTotalAmount: gstTotalAmount,
                                                                                        total_Coupon_Amount: total_Coupon_Amount
                                                                                    }
                                                                                });
                                                                            }} className="gi-btn-3 w-full mt-5 transition-all duration-[0.3s] ease-in-out overflow-hidden
                                                             text-center relative rounded-[5px] py-[10px] text-[13px] bg-red-800 text-white tracking-[0] font-medium 
                                                              items-center hover:bg-[#4b5966] hover:text-[#fff] uppercase">Checkout</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        )
                                    }
                                </>
                            ) : (
                                <div className="flex flex-col items-center justify-center h-screen gap-5">
                                    <MdOutlineRemoveShoppingCart className="text-gray-400" size={100} />
                                    <h3 className="text-center text-[#777] text-lg">
                                        Your cart is currently empty. Start exploring our products and add your favorites to the cart!
                                    </h3>
                                    <button onClick={() => navigate("/all-best-selling-product")} className="w-full max-w-[200px] sm:w-1/3 mt-5 transition-all duration-[0.3s] ease-in-out overflow-hidden
                                                             text-center relative rounded-[5px] py-[10px] text-[13px] bg-red-800 text-white tracking-[0] font-medium 
                                                              items-center hover:bg-[#4b5966] hover:text-[#fff] uppercase">Shop Now</button>
                                </div>
                            )
                        }
                        {/* <---------- Home_Private_Confidential -------> */}
                        <Home_Private_Confidential />
                        {/* <-------- Footer section's ----------> */}
                        <Footer />
                    </>
                )
            }
        </div>
    )
}

export default Cart